module.exports = __webpack_public_path__ + "img/sonic.6e14c9f5.png";